<template>
  <b-modal id="modal-request" ref="modal" size="lg" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-calendar"></em> Compensation day Request</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Leave Date</label>
                <div class="col-8 mb-3">
                  <div class="row" v-for="(item, i) in items">

                    <div class="col-sm-5 mb-1">
                      <flat-pickr :config="config" v-model="item.date"></flat-pickr>
                    </div>
                    <div class="col-sm-4 mb-1">
                      <b-form-select :options="option_hours" v-model="item.hours"></b-form-select>
                    </div>
                    <div class="col-sm-1 mb-1" v-if="i ==0">
                      <button type="button" class="btn btn-success btn-sm" @click="addItem" data-title="Add">
                        <em class="fa fa-plus mr-1"></em>Add</button>
                    </div>
                    <div class="col-sm-1 mb-1" v-else>
                      <em class="fa fa-trash mr-1" style="cursor: pointer" @click="deleteItem(i)"></em>
                    </div>
                  </div>
                </div>


              </div>
              <div class="form-row" v-if="!this.$store.getters.companySettings.is_auto_approve">
                <label class="col-md-3">Project</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_project" v-model="input_data.project" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Note</label>
                <div class="col-md-6 mb-3">
                  <b-form-textarea rows="3" v-model="input_data.reason" max-rows="6"></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">PIC when leave</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_pic" v-model="input_data.pic" :reduce="data=>data.emp_id" label="emp_name"></v-select>
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor :emp_id="emp_id.toString()" ></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="stat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="stat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BForm, BFormGroup, BFormInput, BFormTextarea, BFormFile, BButton, BFormSelect, BModal} from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
export default {
  name: "CompensatoryInput",
  components:{
    ListSupervisor,
    Breadcrumb,
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BFormTextarea,
    BFormFile,
    BButton,
    BFormSelect,
    BModal,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      emp_name:"",
      stat_id:0,
      emp_id:"",
      input_data:{
        request_date:"",
        project:"",
        reason:"",
        pic:"",
        file:[]
      },
      items:[{hours:8}],
      items_deleted:[],
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
      option_project:[],
      option_pic:[],
      option_hours:[]
    }
  },
  methods:{
    handleOk(evt){
      evt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.items =[{hours:8}]
      this.$parent.data = null
      this.input_data = {}
      this.$refs.modal.hide()
    },
    onSubmit(){
      if(!this.checkValidItem()){
        return false
      }
      let userProfile = this.$store.getters.userProfile.data.attributes
      let payload = {
        emp_id:this.$store.getters.empId,
        user_id:this.$store.getters.userId,
        comp_unit_id: userProfile.emp_unit_id,
        comp_activity:this.items,
        comp_reason:this.input_data.reason,
        comp_project_id:this.input_data.project,
        comp_compstat_id:this.stat_id,
        comp_contact_id:this.input_data.pic,
        comp_activity_deleted:this.items_deleted
      }
      if (this.data !== null){
        payload.id = this.data.id
        payload.number = this.data.number
        AxiosCall.Put(payload, urlApi.compensatory.update).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.compensatory.add).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    checkValidItem(){
      if (this.items.length == 0){
        this.$parent.errorMessage('Pleas add items')
        return false
      }

      for (let data of this.items){
        if (data.date === undefined || data.date==="" || data.date === null){
          this.$parent.errorMessage("Please fill date.")
          return false
        }

      }
      return true
    },
    onBack(){
      this.$router.push({path:"/compensatory"})
    },
    addItem(){
      this.items.push({hours:8})
    },
    deleteItem(i){
      this.items_deleted.push(this.items[i])
      this.items.splice(i, 1)
    },
    getProject(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.project.projectAll).then(res=>{
        if(res.success){
          this.option_project = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getPIC(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.contact.list).then(res=>{
        if (res.success){
          this.option_pic = res.atributes
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    setData(){
      this.getProject()
      this.getPIC()
      setTimeout(()=>{
        this.emp_id = this.$store.getters.empId
        if(this.data !== null) this.getDetail()
      }, 100)

    },
    getDetail(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.compensatory.detail).then(res=>{
        if (res.success){
          this.input_data = {
            project:res.atributes.project_id,
            reason:res.atributes.reason,
            pic:res.atributes.contact_id,
          }
          this.emp_id= res.atributes.emp_id
          this.items = JSON.parse(res.atributes.items)
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  },
  mounted() {
    for (let i = 1; i<=12; i++){
      this.option_hours.push({text:i+" hours", value:i})
    }
    let userProfile = this.$store.getters.userProfile.data.attributes
    this.emp_name = userProfile.emp_name
  }
}
</script>